import { render, staticRenderFns } from "./LayoutView.vue?vue&type=template&id=1a42b25f&scoped=true"
import script from "./LayoutView.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LayoutView.vue?vue&type=style&index=0&id=1a42b25f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a42b25f",
  null
  
)

export default component.exports